import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Checkout() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/cart', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black pt-20 px-4 text-white">
      <div className="max-w-4xl mx-auto">
        Redirecting to cart checkout...
      </div>
    </div>
  );
}
